import React, { useEffect, useState } from 'react';
import '@fontsource/open-sans';
import './style.css';
import {
  CalendarBlank,
  ArrowRight,
  User,
  Hash,
  Tag,
  ArrowsLeftRight,
} from 'phosphor-react';
import moment from 'moment';
import { format } from '~/Utils/Helpers';
import ProspectoDetalhes from '~/Components/Prospectos/ProspectoDetalhes/ProspectoDetalhes';
import { Badge, Modal } from 'react-bootstrap';
import { ArrowSquareOut } from 'phosphor-react';
import { CgArrowsExchange } from 'react-icons/cg';
import Select from 'react-select';
import { customStyles } from '~/Styles/reactSelectStyles';
import { atualizarEtapaProspecto, getEtapas } from '~/Services/Service';
import { toast } from 'react-toastify';
import { IoLogoWhatsapp } from 'react-icons/io';
import { stubString } from 'lodash';

function CardProspecto({ info, etapa, onStatusChange }) {
  const [showModalStatus, setShowModalStatus] = useState(false);
  const [statusSelecionado, setStatusSelecionado] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [corretor, setCorretor] = useState(null);

  const abrirGuiaProspecto = () => {
    const url = `/prospecto/gestao-crm/${info.codigo}`;
    window.open(url, '_blank');
  };

  const abrirModalStatus = () => {
    setShowModalStatus(true);
  };

  const fecharModalStatus = () => {
    setShowModalStatus(false);
    setStatusSelecionado(null);
  };

  const handleSalvarStatus = async () => {
    if (!statusSelecionado) return;

    if (statusSelecionado.value === info.codigo_etapa_prospecto) {
      toast.warning('O novo status não pode ser igual ao status atual!');
      return;
    }

    setSalvando(true);
    try {
      const request = await atualizarEtapaProspecto({
        codigo_prospecto: info.codigo,
        etapa_atual: info.codigo_etapa_prospecto,
        nova_etapa: statusSelecionado.value,
        codigo_familia: info.codigo_familia,
      });

      if (request && request.status === 200) {
        toast.success('Status atualizado com sucesso!');
        fecharModalStatus();

        if (onStatusChange) {
          onStatusChange();
        }
      } else {
        toast.error('Erro ao atualizar o status do prospecto.');
      }
    } catch (error) {
      console.error('Erro ao atualizar etapa:', error);
      toast.error('Erro ao atualizar o status do prospecto.');
    } finally {
      setSalvando(false);
    }
  };

  const [etapasOptions, setEtapasOptions] = useState([]);

  useEffect(() => {
    const validacaoModalFechado =
      showModalStatus === false || etapasOptions.length > 0;
    if (validacaoModalFechado) return;

    (async () => {
      const response = await getEtapas();
      const etapas = response.map(item => {
        return { value: item.codigo, label: item.descricao };
      });
      setEtapasOptions(etapas);
    })();
  }, [showModalStatus]);

  useEffect(() => {
    if (info.corretor) {
      nomeCorretor();
    }
  }, [info.corretor]);

  const nomeCorretor = () => {
    let nome = info.corretor.split(' ');

    setCorretor(nome[0] + ' ' + nome[nome.length - 1]);
  };

  const statusIgualAtual =
    statusSelecionado &&
    statusSelecionado.value === info.codigo_etapa_prospecto;
  return (
    <>
      <div
        className="card shadow-sm mb-2 open-sans container-fluid px-0"
        style={{
          borderRadius: '8px',
          minWidth: 0,
          width: 300,
          maxWidth: 300,
          background: '#eef2fa',
          border: info.interesse_social ? '2px solid #ff9800' : '1.5px solid #2196f3',
          boxSizing: 'border-box',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {info.flag_represado_bolsao && (
          <div
            style={{
              position: 'absolute',
              top: '10px',
              left: '-40px',
              background: 'rgba(242, 100, 34, 0.8)',
              color: 'white',
              padding: '5px 40px',
              transform: 'rotate(-45deg)',
              fontSize: '12px',
              fontWeight: 'bold',
              zIndex: 1,
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            }}
          >
            Represado
          </div>
        )}

        <div className="card-body p-1 pb-1" style={{ paddingBottom: 8 }}>
          <div className="d-flex mb-1 gap-1 flex-wrap">
            <div className="d-flex flex-column ml-1 justify-content-around">
              <small className="text-secondary fw-medium">#{info.codigo}</small>
              {info['codigo_origem_cadastro'] == 9 && (
                <div>
                  <span className="badge bg-primary small">INDICAÇÃO</span>
                </div>
              )}
              {info.interesse_social && (
                <div className="d-flex align-items-center" style={{ gap: 4 }}>
                  <span style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#ff9800',
                  }} />
                  <span style={{ fontSize: '0.65rem', color: '#ff9800', fontWeight: 600 }}>
                    Interesse Social
                  </span>
                </div>
              )}
            </div>
            <div className="d-flex gap-1" style={{ marginLeft: 'auto' }}>
              <div
                className="btn btn-outline-warning d-flex align-items-center mr-3 justify-content-center p-0"
                onClick={abrirModalStatus}
                style={{ width: '30px', height: '30px' }}
              >
                <CgArrowsExchange size={16} weight="bold" />
              </div>

              <div
                className="btn btn-sm btn-outline-primary d-flex align-items-center"
                onClick={abrirGuiaProspecto}
              >
                <span className="open-sans">Expandir</span>
                <ArrowSquareOut
                  className="ml-2"
                  style={{ marginBottom: '2px' }}
                />
              </div>
            </div>
          </div>

          <div>
            <h4
              className="px-1 mb-0 fw-bold text-truncate"
              style={{
                color: '#293C66',
                fontSize: '0.98rem',
              }}
              title={info['nome']}
            >
              {info['nome']}
            </h4>
            {info.contato && (
              <div className="d-flex justify-content-between align-items-center">
                <a
                  className="text-primary px-1 text-decoration-none d-inline-flex align-items-center text-truncate small span-click"
                  style={{ opacity: 0.8 }}
                  href={`https://api.whatsapp.com/send?phone=55${info.contato}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {format.celular(info.contato)}
                  {info.contato && info.contato.length > 10 && (
                    <span className="ms-1">
                      <IoLogoWhatsapp color="25d366" size={18} />
                    </span>
                  )}
                </a>
                <small className="d-flex align-items-center text-dark px-2">
                  <CalendarBlank className="me-1" size={14} />
                  {info['data_cadastro']
                    ? moment(info['data_cadastro']).format('DD/MM/YYYY')
                    : moment('01-01-2025').format('DD/MM/YYYY')}
                </small>
              </div>
            )}
          </div>
          <hr
            className="my-1"
            style={{ borderColor: '#cfd8dc', margin: '2px 0 4px 0' }}
          />
          <div className="px-1">
            <div className="mb-1">
              <small
                className="d-block text-muted "
                style={{ fontWeight: '600', fontSize: '0.7rem' }}
              >
                Empreendimento
              </small>
              <span
                className="d-block text-truncate small"
                style={{ color: '#293c66' }}
                title={info.empreendimento}
              >
                {info.empreendimento || '-'}
              </span>
            </div>
            {info.nome_gestor && (
              <div className="mb-1">
                <small
                  className="d-block text-muted "
                  style={{ fontWeight: '600', fontSize: '0.7rem' }}
                >
                  Gestor Lead
                </small>
                <span
                  className="d-block text-truncate small"
                  style={{ color: '#293c66' }}
                  title={info.nome_gestor}
                >
                  {info.nome_gestor || '-'}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between gap-2">
              <div className="flex-fill" style={{ minWidth: 0 }}>
                <small
                  className="d-block text-muted "
                  style={{ fontWeight: '600', fontSize: '0.7rem' }}
                >
                  Corretor
                </small>
                <span
                  className="d-block text-truncate small"
                  style={{ color: '#293c66' }}
                  title={corretor && info.codigo_corretor != 0 ? corretor : '-'}
                >
                  {corretor && info.codigo_corretor != 0 ? corretor : '-'}
                </span>
              </div>

              <div
                className="flex-fill"
                style={{ minWidth: 0, justifyItems: 'end' }}
              >
                <small
                  className="d-block text-muted"
                  style={{ fontWeight: '600', fontSize: '0.7rem' }}
                >
                  Imobiliária
                </small>
                <span
                  className={
                    info.imobiliaria
                      ? 'px-2 py-1 small fw-medium d-flex align-items-center'
                      : 'd-block text-truncate small fw-normal'
                  }
                  style={
                    info.imobiliaria
                      ? {
                          color: info.cor_imobiliaria || 'black',
                          height: 22,
                        }
                      : { color: '#293c66' }
                  }
                  title={info.imobiliaria ? info.imobiliaria : '-'}
                >
                  {info.imobiliaria ? info.imobiliaria : '-'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModalStatus}
        onHide={fecharModalStatus}
        centered
        size="lg"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: '#f8f9fa',
            borderBottom: '2px solid #2196f3',
          }}
        >
          <Modal.Title className="d-flex align-items-center gap-2">
            <ArrowsLeftRight size={24} weight="bold" color="#2196f3" />
            <span style={{ color: '#293C66' }}>
              Alterar Status do Prospecto
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '1.5rem' }}>
          <div
            className="card mb-4"
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              backgroundColor: '#f8f9fa',
            }}
          >
            <div className="card-body p-3">
              <h6
                className="mb-3"
                style={{ color: '#293C66', fontWeight: 600 }}
              >
                Informações do Prospecto
              </h6>

              <div className="row g-3">
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <Hash
                      size={18}
                      weight="bold"
                      color="#6c757d"
                      style={{ marginTop: '2px' }}
                    />
                    <div>
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '0.75rem' }}
                      >
                        Código
                      </small>
                      <span className="fw-bold" style={{ color: '#293C66' }}>
                        {info.codigo}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="d-flex align-items-start gap-2">
                    <User
                      size={18}
                      weight="bold"
                      color="#6c757d"
                      style={{ marginTop: '2px' }}
                    />
                    <div style={{ flex: 1 }}>
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '0.75rem' }}
                      >
                        Nome
                      </small>
                      <span
                        className="fw-bold text-truncate d-block"
                        style={{ color: '#293C66' }}
                        title={info.nome}
                      >
                        {info.nome}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h6 className="mb-3" style={{ color: '#293C66', fontWeight: 600 }}>
              <Tag size={18} weight="bold" className="mr-1" />
              Mudança de Status
            </h6>

            <div className="mb-3">
              <label
                className="form-label text-muted mb-2"
                style={{ fontSize: '0.85rem' }}
              >
                Status Atual
              </label>
              <div
                className="p-3"
                style={{
                  backgroundColor: '#e3f2fd',
                  border: '1px solid #2196f3',
                  borderRadius: '6px',
                }}
              >
                <span
                  className="fw-bold"
                  style={{ color: '#1976d2', fontSize: '0.95rem' }}
                >
                  {info.descricao_status || 'Não definido'}
                </span>
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="selectStatus"
                className="form-label text-muted mb-2"
                style={{ fontSize: '0.85rem' }}
              >
                Novo Status <span className="text-danger">*</span>
              </label>
              <Select
                id="selectStatus"
                placeholder="Selecione o novo status..."
                options={etapasOptions}
                value={statusSelecionado}
                onChange={selectedOption => {
                  setStatusSelecionado(selectedOption);
                }}
                isClearable
                styles={{
                  ...customStyles,
                  control: (base, state) => ({
                    ...base,
                    ...(customStyles.control
                      ? customStyles.control(base, state)
                      : {}),
                    minHeight: '45px',
                    borderColor: state.isFocused
                      ? '#2196f3'
                      : statusIgualAtual
                      ? '#dc3545'
                      : '#ced4da',
                    boxShadow: state.isFocused
                      ? '0 0 0 0.2rem rgba(33, 150, 243, 0.25)'
                      : 'none',
                    '&:hover': {
                      borderColor: statusIgualAtual ? '#dc3545' : '#2196f3',
                    },
                  }),
                }}
                noOptionsMessage={() => 'Nenhum status disponível'}
              />
              {!statusSelecionado && (
                <small
                  className="text-muted mt-1 d-block"
                  style={{ fontSize: '0.75rem' }}
                >
                  Selecione um status para continuar
                </small>
              )}
              {statusIgualAtual && (
                <small
                  className="text-danger mt-1 d-block"
                  style={{ fontSize: '0.75rem', fontWeight: 500 }}
                >
                  O novo status não pode ser igual ao status atual
                </small>
              )}
            </div>

            {statusSelecionado && !statusIgualAtual && (
              <div
                className="alert alert-info d-flex align-items-center gap-2 mb-0"
                style={{
                  backgroundColor: '#e8f5e9',
                  border: '1px solid #4caf50',
                  borderRadius: '6px',
                }}
              >
                <ArrowsLeftRight size={20} weight="bold" color="#2e7d32" />
                <div style={{ flex: 1 }}>
                  <small style={{ color: '#2e7d32', fontWeight: 500 }}>
                    O status será alterado de{' '}
                    <strong>"{info.descricao_status || 'Não definido'}"</strong>{' '}
                    para <strong>"{statusSelecionado.label}"</strong>
                  </small>
                </div>
              </div>
            )}

            {statusIgualAtual && (
              <div
                className="alert alert-warning d-flex align-items-center gap-2 mb-0"
                style={{
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffc107',
                  borderRadius: '6px',
                }}
              >
                <ArrowsLeftRight size={20} weight="bold" color="#856404" />
                <div style={{ flex: 1 }}>
                  <small style={{ color: '#856404', fontWeight: 500 }}>
                    O prospecto já está no status{' '}
                    <strong>"{info.descricao_status}"</strong>. Selecione um
                    status diferente.
                  </small>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer
          style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}
        >
          <button
            className="btn btn-secondary"
            onClick={fecharModalStatus}
            disabled={salvando}
            style={{ minWidth: '100px' }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSalvarStatus}
            disabled={!statusSelecionado || salvando || statusIgualAtual}
            style={{ minWidth: '120px' }}
          >
            {salvando ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Salvando...
              </>
            ) : (
              <>
                <ArrowRight size={16} weight="bold" className="mr-1" />
                Salvar Alteração
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CardProspecto;
